import { Sparkles } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function Benefit({ text, testid = "benefit-line" }) {
  const { t } = useLang();
  return (
    <div
      data-testid={testid}
      className="mt-8 flex flex-col md:flex-row md:items-center gap-3 md:gap-5 p-4 md:p-5 bg-[#14352a] text-[#faf8f5] border-l-4 border-[#d9a92e]"
    >
      <span className="inline-flex items-center gap-1.5 shrink-0 px-3 py-1 rounded-full bg-[#9a7218]/25 text-[#d9a92e] font-mono-label text-[9px] border border-[#9a7218]/40">
        <Sparkles className="h-3 w-3" /> {t("What your team gets")}
      </span>
      <p className="text-sm md:text-[15px] leading-relaxed text-[#faf8f5]/90">
        {t(text)}
      </p>
    </div>
  );
}
